import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutInfo } from '@/mocks/aboutData';

export default function About() {
  return (
    <>
      <Navbar />
      <main>
        <div className="pt-16 md:pt-18 bg-background-50">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="py-6 md:py-10">
            <div className="container-custom">
              <div className="text-center mb-10">
                <h1 className="font-serif text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
                  关于{aboutInfo.brandName}
                </h1>
                <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
                  {aboutInfo.slogan}
                </p>
              </div>

              <div className="max-w-3xl mx-auto mb-14">
                <div className="bg-white rounded-2xl p-6 md:p-8">
                  <h2 className="font-serif text-xl font-bold text-foreground-900 mb-4">品牌介绍</h2>
                  {aboutInfo.description.split('\n\n').map((paragraph, i) => (
                    <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>

              <div className="mb-14">
                <h2 className="font-serif text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8">
                  我们的优势
                </h2>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
                  {aboutInfo.features.map((feature) => (
                    <div
                      key={feature.title}
                      className="bg-white rounded-xl p-5 md:p-6 text-center hover:bg-background-50 transition-colors"
                    >
                      <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl">
                        <i className={`${feature.icon} text-xl`}></i>
                      </div>
                      <h3 className="font-serif font-semibold text-foreground-900 text-sm md:text-base mb-2">
                        {feature.title}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mb-14">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {aboutInfo.stats.map((stat) => (
                    <div key={stat.label} className="text-center p-4">
                      <div className="font-serif text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                        {stat.value}
                      </div>
                      <div className="text-xs md:text-sm text-foreground-500">
                        {stat.label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mb-14">
                <h2 className="font-serif text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8">
                  用户口碑
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                  {aboutInfo.reputation.map((review) => (
                    <div
                      key={review.name}
                      className="bg-white rounded-xl p-5 md:p-6"
                    >
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                          <img
                            src={review.avatar}
                            alt={review.name}
                            className="w-full h-full object-cover"
                            loading="lazy"
                          />
                        </div>
                        <div>
                          <div className="font-medium text-foreground-900 text-sm">{review.name}</div>
                          <div className="flex items-center gap-0.5">
                            {Array.from({ length: 5 }).map((_, i) => (
                              <i
                                key={i}
                                className={`text-xs ${
                                  i < review.rating
                                    ? 'ri-star-fill text-yellow-500'
                                    : 'ri-star-line text-foreground-300'
                                }`}
                              ></i>
                            ))}
                          </div>
                        </div>
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                        &ldquo;{review.comment}&rdquo;
                      </p>
                      <p className="text-xs text-foreground-400">{review.date}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="max-w-3xl mx-auto" id="contact">
                <h2 className="font-serif text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8">
                  联系我们
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white rounded-xl p-6 md:p-8">
                    <h3 className="font-serif font-semibold text-foreground-900 mb-4">联系方式</h3>
                    <ul className="space-y-3">
                      <li className="flex items-center gap-3 text-sm text-foreground-600">
                        <div className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg flex-shrink-0">
                          <i className="ri-mail-line"></i>
                        </div>
                        <span>{aboutInfo.contact.email}</span>
                      </li>
                      <li className="flex items-center gap-3 text-sm text-foreground-600">
                        <div className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg flex-shrink-0">
                          <i className="ri-wechat-line"></i>
                        </div>
                        <span>微信：{aboutInfo.contact.wechat}</span>
                      </li>
                      <li className="flex items-center gap-3 text-sm text-foreground-600">
                        <div className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg flex-shrink-0">
                          <i className="ri-map-pin-line"></i>
                        </div>
                        <span>{aboutInfo.contact.address}</span>
                      </li>
                      <li className="flex items-center gap-3 text-sm text-foreground-600">
                        <div className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg flex-shrink-0">
                          <i className="ri-time-line"></i>
                        </div>
                        <span>{aboutInfo.contact.workingHours}</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white rounded-xl p-6 md:p-8">
                    <h3 className="font-serif font-semibold text-foreground-900 mb-4">在线留言</h3>
                    <form
                      className="space-y-3"
                      data-readdy-form=""
                      action="https://sakuraon.github.io/api/form/d9u3khv8l97n3eas3gn0"
                      method="POST"
                    >
                      <div>
                        <input
                          type="text"
                          name="name"
                          placeholder="您的姓名"
                          required
                          className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                        />
                      </div>
                      <div>
                        <input
                          type="email"
                          name="email"
                          placeholder="您的邮箱"
                          required
                          className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                        />
                      </div>
                      <div>
                        <textarea
                          name="message"
                          placeholder="请输入您的留言..."
                          rows={4}
                          maxLength={500}
                          required
                          className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                        ></textarea>
                      </div>
                      <input
                        type="text"
                        name="phone_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden={true}
                        readOnly
                        className="honeypot-field"
                      />
                      <button
                        type="submit"
                        className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium text-sm transition-colors whitespace-nowrap"
                      >
                        发送留言
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: `关于${aboutInfo.brandName}`,
            description: aboutInfo.slogan,
            about: {
              '@type': 'Organization',
              name: aboutInfo.brandName,
              foundingDate: aboutInfo.founded,
              description: aboutInfo.description,
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'ContactPage',
            name: `${aboutInfo.brandName} 联系我们`,
            mainEntity: {
              '@type': 'Organization',
              name: aboutInfo.brandName,
              email: aboutInfo.contact.email,
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'customer service',
                email: aboutInfo.contact.email,
                hoursAvailable: [
                  {
                    '@type': 'OpeningHoursSpecification',
                    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                    opens: '09:00',
                    closes: '22:00',
                  },
                ],
                availableLanguage: ['Chinese', 'Japanese'],
              },
            },
          }),
        }}
      />
    </>
  );
}